<template>
	<div class="rightPart">
		<div class="echartBox">
			<div class="title">
				<span class="">
					充电桩使用情况
				</span>
			</div>
			<div id="echart1"></div>
		</div>
		<div class="echartBox">
			<div class="title">
				<span class="">
					派工情况
				</span>
			</div>
			<div class="tabBox subFont">
				<div class="tabList disBetween listItemClass1">
					<div class="listItem itemOne">时间</div>
					<div class="listItem itemTwo">类型</div>
					<div class="listItem itemThree">地区</div>
					<div class="listItem itemFour">人员</div>
				</div>
				<div class="contentList">
					<div v-loading="loading1" class="tabList  disBetween" v-for="(item,inx) in tabList" :key="inx"
						:class="'listItemClass'+(inx%2 )">
						<div class="listItem itemOne">{{item.orderTime}}</div>
						<div class="listItem itemTwo status1">{{item.statueText}}</div>
						<a href="#" class="listItem itemThree ellipsis" :title="item.area">{{item.areaName}}</a>
						<div class="listItem itemFour">{{item.workUserName}}</div>
					</div>
				</div>

			</div>
		</div>
		<div class="echartBox">
			<div class="title">
				<span class="">
					警告信息
				</span>
			</div>
			<div class="warnBox">
				<div class="scorllBox">
					<div class="warnItem subFont" v-for="(item,inx) in warnList" :key="inx" v-loading="loading2">
						<div class="warnNew disBetween">
							<div class="warnLeft disBetween">
								<div class="warnOne">
									设备 : {{item.equipmentNo}}
								</div>
								<div class="warnTwo status1">
									{{item.statueText}}
								</div>
							</div>
							<div class="warnRight">
								{{item.alarmTime}}
							</div>
						</div>
						<div class="warnText">
							{{item.message}}
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'rightPart',
		data() {
			return {
				objData1: {
					// 横坐标
					labArr: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
					// 用电量数据
					dataArr1: ['0', '4', '27', '2', '10', '3', '1', '1', '3', '2', '0', '3'],
					// 充电次数数据
					dataArr2: ['0', '4', '27', '2', '10', '3', '1', '1', '3', '2', '0', '5'],
				},
				tabList: [],
				warnList:[],
				loading1:false,
				loading2:false,
			}
		},
		mounted() {
			// this.init()
			this.getdata()
		},
		methods: {
			
			getdata() {
				this.loading1=true
				this.loading2=true
				let param  = {
					pageNo:1,
					pageSize:10
				}
				var self = this
				this.tabList = []
				this.$api.workOrderList(param).then(res => {
					console.log(res)
					res.obj.list.forEach((item)=>{
						
						if(item.orderType ==1){
							item.statueText = '故障'
						}else if(item.orderType ==2){
							item.statueText = '巡检'
						}
						self.tabList.push(item)
					})
					
					
				}).catch(function(error) {
					console.log(error);
				});
				
				let param1  = {
					pageNo:1,
					pageSize:10
				}
				this.warnList = []
				this.$api.alarmInformationList(param1).then(res => {
					console.log(res)
					 res.obj.list.forEach((item)=>{
						
						if(item.equipmentStatus ==2){
							item.statueText = '异常'
						}
						self.warnList.push(item)
					})
				
				}).catch(function(error) {
					console.log(error);
				});
				
				let param2 = {
					year:'2022'
				}
				
				this.$api.useCondition(param2).then(res => {
					console.log(res)
					self.objData1.labArr = res.obj.monthList
					self.objData1.dataArr1 = res.obj.electricNumberList
					self.objData1.dataArr2 = res.obj.chargeNumberList 
					this.$nextTick(() => {
						this.drawLine1()
					})
					console.log(self.objData1)
				
				}).catch(function(error) {
					console.log(error);
				});
				this.loading1=false
				this.loading2=false	
			},
			init() {
				this.$nextTick(() => {
					this.drawLine1()
				})
			},
			drawLine1() {
				let that = this
				const wid = 8;
				const w1 = Math.sin(Math.PI / 6) * wid; //4
				const w2 = Math.sin(Math.PI / 3) * wid; // 6.8
				const snapHeight = wid / 2;
				const CubeLeft = this.$echarts.graphic.extendShape({
					shape: {
						x: 0,
						y: 0
					},
					buildPath: function(ctx, shape) {
						// 会canvas的应该都能看得懂，shape是从custom传入的
						const xAxisPoint = shape.xAxisPoint
						const c0 = [shape.x, shape.y]
						const c1 = [shape.x - w2, shape.y]
						const c2 = [shape.x - w2, xAxisPoint[1]]
						const c3 = [shape.x, xAxisPoint[1]]
						ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1])
							.closePath()
					}
				})
				// 绘制右侧面
				const CubeRight = this.$echarts.graphic.extendShape({
					shape: {
						x: 0,
						y: 0
					},
					buildPath: function(ctx, shape) {
						const xAxisPoint = shape.xAxisPoint
						const c1 = [shape.x, shape.y]
						const c2 = [shape.x, xAxisPoint[1]]
						const c3 = [shape.x + w1, xAxisPoint[1] - w2 + snapHeight]
						const c4 = [shape.x + w1, shape.y - w2 + snapHeight]
						ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1])
							.closePath()
					}
				})
				// 绘制顶面
				const CubeTop = this.$echarts.graphic.extendShape({
					shape: {
						x: 0,
						y: 0
					},
					buildPath: function(ctx, shape) {
						//
						const c1 = [shape.x, shape.y]
						const c2 = [shape.x + w1, shape.y - w2 + snapHeight] //右点
						const c3 = [shape.x - w2 + w1, shape.y - w2 + snapHeight]
						const c4 = [shape.x - w2, shape.y]
						ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1])
							.closePath()
					}
				})
				// 注册三个面图形
				this.$echarts.graphic.registerShape('CubeLeft', CubeLeft)
				this.$echarts.graphic.registerShape('CubeRight', CubeRight)
				this.$echarts.graphic.registerShape('CubeTop', CubeTop)
				const myChart = this.$echarts.init(document.getElementById('echart1'))
				myChart.clear() 
				myChart.setOption({
					//你的代码
					// tooltip: {
					// 	// show: false,
					// 	trigger: 'axis',
					// 	axisPointer: {
					// 		type: 'shadow'
					// 	},

					// },

					tooltip: {
						trigger: 'axis',
						backgroundColor: 'rgba(255,255,255,0.9)',
						padding: [15],
						borderWidth: 0,
						formatter: function(params) {
							let str = params[0].name + '<br/>'
							for (let item of params) {
								str +=
									"<div style='text-align: left;'><span style='display:inline-block;width:10px;height:10px;border-radius:10px;background-color:" +
									item.color + ";'></span>" + "\t" + item.seriesName + " : " + item.value +
									'<br/></div>'
							}
							return str

						},
					},
					grid: {
						left: '8%',
						right: '6%',
						top: '15%',
						bottom: '5%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: that.objData1.labArr,
						axisLine: {
							show: true,
							lineStyle: {
								color: '#fff',
								width: 1
							}
						},
						axisTick: {
							show: false,
							length: 9,
							alignWithLabel: true,
							lineStyle: {
								color: '#fff'
							}
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#565f6a',
								width: 1
							}
						},
						axisLabel: {
							color: '#c9d9ec',
							interval: 0,
						},
						splitLine: {
							show: false,
							lineStyle: {
								color: '#c9d9ec',
							}
						},
					},
					yAxis: [{
						name: '           用电量（kWh）',
						nameTextStyle: { //y轴上方单位的颜色
							color: '#c9d9ec',
							fontSize: 16
						},
						type: 'value',
						axisLine: {
							show: false,
							lineStyle: {
								color: '#00deff',
							}
						},
						axiosTick: {
							show: false
						},
						axisLabel: {
							fontSize: 16,
							color: "#c9d9ec",
						},
						splitLine: { //分割线配置
							lineStyle: {
								color: "#4b6a7d",
							}
						},
					}, {
						type: "value",
						name: '充电次数（次）        ',
						nameTextStyle: { //y轴上方单位的颜色
							color: '#c9d9ec',
							fontSize: 16
						},
						type: 'value',
						axisLine: {
							show: false,
							lineStyle: {
								color: '#00deff',
							}
						},
						axiosTick: {
							show: false
						},
						axisLabel: {
							fontSize: 16,
							color: "#c9d9ec",
						},
						splitLine: { //分割线配置
							lineStyle: {
								color: "#4b6a7d",
							}
						},
					}, ],
					series: [{
						type: 'custom',
						name: "用电量",
						renderItem: (params, api) => {
							const location = api.coord([api.value(0), api.value(1)]);
							location[0] = location[0] + wid * 0;
							const xlocation = api.coord([api.value(0), 0]);
							xlocation[0] = xlocation[0] + wid * 0;
							return {
								type: 'group',
								children: [{
									type: 'CubeLeft',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1],
										xAxisPoint: xlocation
									},
									style: {
										fill: new this.$echarts.graphic.LinearGradient(0, 0, 0,
											1, [{
													offset: 0,
													color: '#40fbeb'
												},
												{
													offset: 1,
													color: '#1c7168'
												}
											])
									}
								}, {
									type: 'CubeRight',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1],
										xAxisPoint: xlocation
									},
									style: {
										fill: new this.$echarts.graphic.LinearGradient(0, 0, 0,
											1, [{
													offset: 0,
													color: '#25dbc9'
												},
												{
													offset: 1,
													color: '#1c7168'
												}
											])
									}
								}, {
									type: 'CubeTop',
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1],
										xAxisPoint: xlocation
									},
									style: {
										fill: new this.$echarts.graphic.LinearGradient(0, 0, 0,
											1, [{
													offset: 0,
													color: '#84fffb'
												},
												{
													offset: 1,
													color: '#84fffb'
												}
											])
									}
								}]
							}
						},
						color: '#84fffb',
						data: that.objData1.dataArr1
					}, {
						name: "充电次数",
						type: "line",
						yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
						smooth: true, //平滑曲线显示
						symbol: "circle", //标记的图形为实心圆
						symbolSize: 0, //标记的大小
						color: ["#277b3d"],
						data: that.objData1.dataArr2,
					}, ]
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "rightPart.scss"
</style>
